<template>
    <div id="funcionario-listagem">
        <my-tour v-if="itens.length > 0 && statusSimulador != 2" :steps="steps" name="steps-funcionarios"></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Usuários" />

                <div class="row">
                    <div class="col s12 m12 l10">
                        <div class="card-panel">
                            <grid :data="paginationConfig.itens" :columns="gridColumns" :filter-key="searchQuery"
                                :editar="'/usuario/editar/'" :deletar="'funcionario/'" @deleted="({item}) => paginationConfig.itens.splice(paginationConfig.itens.indexOf(item), 1) ">
                            </grid>
                            <Pagination v-if="gridData.length > 0" :perPage="paginationConfig.perPage"
                                :qty="paginationConfig.qty" :setCurrent="setCurrent"
                                :current="paginationConfig.current" />
                        </div>
                    </div>

                    <!-- INICO FILTRO -->
                    <card title="Filtros" :showActions="showCardActionsFilter" @clearFilter="clearFilter">
                        <template slot="content">
                            <div class="row" id="filter2">
                                <div class="Search">
                                    <div class="col s12">
                                        <span class="Search__title grey-text">Por Usuário:</span>
                                    </div>
                                    <div class="chip mt-3" v-for="func in getFuncionarioData">
                                        {{func.pessoa_nome}}
                                        <i class="close material-icons"
                                            @click="removeFilterFuncionario(func.id)">close</i>
                                    </div>
                                    <div class="Search input-field col s12 input-search">
                                        <i class="material-icons">person_outline</i>
                                        <input type="text" v-model="filtro.funcionario" class="autocomplete">
                                        <i @click="clearFieldFuncionario()"
                                            class="material-icons md-18 grey-text clear">clear</i>
                                        <label for="nome"></label>
                                    </div>
                                </div>

                            </div>

                            <ul class="collection">
                                <li class="collection-item pl-0 pr-0"
                                    style="display: flex;justify-content: space-between;"
                                    v-for="func in funcionariosFiltered">
                                    <!-- <i class="material-icons circle">person_outline</i> -->
                                    <span class="title"
                                        style="text-transform: capitalize; font-size: .9rem">{{ func.pessoa_nome.toLowerCase() }}</span>
                                    <div class="secondary-content">
                                        <input type="checkbox" v-model="checkFuncionarios" :value="func.id"
                                            :id="'func'+func.id" />
                                        <label :for="'func'+func.id"></label>
                                    </div>
                                </li>
                            </ul>


                            <ul class="collection collection-alone with-header" id="filter1"
                                style="border-top: 1px solid rgb(224, 224, 224);">
                                <li class="collection-header pl-0 filtro-topo">
                                    <span class="Search__title grey-text pl-0">Por cargo:</span>

                                </li>

                                <li class="collection-item dismissable pb-0"
                                    style="touch-action: pan-y; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
                                    <input type="checkbox" v-model="checkCargo" value="all" id="allCargo" />
                                    <label for="allCargo"></label>
                                    <span class="title title-alone" style="width: 100%">Todos</span>
                                </li>

                                <li class="collection-item dismissable pb-0" v-for="cargo in cargoItens"
                                    style="touch-action: pan-y; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
                                    <input type="checkbox" v-model="checkCargo" :value="cargo.funcionario_cargo_id"
                                        :id="cargo.funcionario_cargo_id" />
                                    <label :for="cargo.funcionario_cargo_id"></label>
                                    <span class="title title-alone"
                                        style="width: 100%">{{ cargo.funcionario_cargo_nome }}</span>
                                </li>
                            </ul>


                            <ul class="collection collection-alone with-header" id="filter2"
                                v-if="statusSimulador != 2">
                                <li class="collection-header pl-0">
                                    <span class="Search__title grey-text pl-0">Por {{lang.empresa}}:</span>

                                </li>

                                <li class="collection-item dismissable pb-0"
                                    style="touch-action: pan-y; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
                                    <input type="checkbox" v-model="checkEmpresa" value="all" id="allEmpresa" />
                                    <label for="allEmpresa"></label>
                                    <span class="title title-alone" style="width: 100%">Todas</span>
                                </li>

                                <li class="collection-item dismissable pb-0" v-for="empresa in empresaItens"
                                    style="touch-action: pan-y; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
                                    <input type="checkbox" v-model="checkEmpresa" :value="empresa.empresa_id"
                                        :id="'empresa-'+empresa.empresa_id" />
                                    <label :for="'empresa-'+empresa.empresa_id"></label>
                                    <span class="title title-alone"
                                        style="width: 100%">{{ empresa.empresa_nome_fantasia }}</span>
                                </li>
                            </ul>
                        </template>
                    </card>
                </div>
            </div>
            <!--end container-->
        </section>
        <div class="fixed-action-btn active" style="bottom: 50px; right: 19px;">
            <router-link to="/usuario/cadastro" class="btn-floating btn-large btn-default">
                <i class="material-icons">add</i>
            </router-link>
        </div>
    </div>
</template>

<style>
.filtro-topo {
    border-top: none !important;
}
</style>

<script>
import BotaoRemover from '@/components/common/BotaoRemover';
import Grid from '@/components/common/Grid';
import { get } from '@/helpers/api';
import Message from '@/helpers/message';
import TituloPagina from '@/components/common/TituloPagina';

import Pagination from '@/components/common/Pagination/Pagination';
import ListHelper from '@/helpers/list';
import MyTour from '@/components/common/MyTour.vue';

import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
import TourHelper from '@/helpers/tour';
import Card from '@/components/common/Card/Card';
import Auth from '@/store/auth';
import getPalavra from '@/helpers/language';
import {
    isMultiEmpresa
}
    from '@/environment';

export default {
    components: {
        BotaoRemover,
        Grid,
        Card,
        TituloPagina,
        Pagination,
        MyTour
    },
    data: () => ({
        statusSimulador: null,
        paginationConfig: {
            perPage: 20,
            qty: 1,
            current: 1,
            itens: []
        },
        lang: {
            empresa: getPalavra('empresa'),
            empresas: getPalavra('empresa', false, false)
        },
        itens: [],
        itensDefault: [],
        searchQuery: '',
        showCardActionsFilter: true,
        gridData: [],
        checkCargo: [],
        checkEmpresa: [],
        checkFuncionarios: [],
        funcionariosFiltered: [],
        funcionarios: [],
        filtro: {
            cargo: [],
            empresa: [],
            funcionario: [],
        },
        cargoItens: [],
        empresaItens: [],
        steps: [
            {
                parent: 'th[data-key=NOME]',
                target: 'th[data-key=NOME]',
                content: 'Podemos ver a lista de usuários já cadastrados...',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },

            {
                multiempresa: false,
                parent: 'th[data-key=EMPRESA]',
                target: 'th[data-key=EMPRESA]',
                content: 'A empresa em que estão vinculados...',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },
            {
                multiempresa: true,
                parent: 'th[data-key=FRANQUIA]',
                target: 'th[data-key=FRANQUIA]',
                content: 'A franquia em que estão vinculados...',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },

            {
                parent: 'th[data-key=CARGO]',
                target: 'th[data-key=CARGO]',
                content: 'o cargo do funcionário...',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },

            {
                parent: 'th[data-key=ACOES]',
                target: 'th[data-key=ACOES]',
                content: 'editar ou excluí-lo!',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },

            {
                parent: '#filter1',
                target: '#filter1',
                content: 'Se quiser filtrar todos os usuários de por um cargo específico, basta selecionar o cargo e visualizar a listagem novamente!',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false
                }
            },
            {
                parent: '#filter2',
                target: '#filter2',
                content: `Ou se preferir filtrar os usuários pela ${getPalavra('empresa')} que são cadastrados, basta realizar o mesmo processo por este filtro de baixo!`,
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false
                }
            },

            {
                parent: '#left-sidebar-nav',
                target: '#desempenho_funcionarios',
                content: 'Para ver a situação atual dos usuários, ou seja, quantos Leads tem em cada parte da esteira de cada funcionário podemos ver aqui no no menu de Usuários em <b>Situação atual</b>!',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: true,
                    route: '/funcionarios/desempenho',
                    subMenu: true,
                    subMenuTarget: "#group-funcionarios"
                }
            },
            {
                parent: '',
                target: '',
                content: '',
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false,
                    // route: '/gerenciamento-leads'
                }
            },

        ],
    }),

    async created() {
        // verifica se pode acessar componente

        if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1) {
            this.$router.push('/sempermissao');
        }


        this.statusSimulador = await Auth.statusSimulador();

        //this.gridColumns = ['id', 'Nome', this.lang.empresas, 'Cargo'];


        this.steps = TourHelper.createSteps(this.steps);
        let self = this;

        get('funcionario').then(function (response) {
            self.itens = response.data.result.data;
            self.itensDefault = response.data.result.data;

            self.itens.forEach((obj) => {
                if (!obj.empresa) {
                    obj.empresa = {
                        empresa_id: null,
                        empresa_nome_fantasia: '',
                    }
                }

                if (isMultiEmpresa) {
                    self.gridData.push({
                        id: obj.funcionario_id,
                        Nome: obj.pessoa.pessoa_nome,
                        Franquia: obj.empresa.empresa_nome_fantasia,
                        Cargo: obj.funcionario_cargo.funcionario_cargo_nome
                    });

                } else {

                    self.gridData.push({
                        id: obj.funcionario_id,
                        Nome: obj.pessoa.pessoa_nome,
                        Empresa: obj.empresa.empresa_nome_fantasia,
                        Cargo: obj.funcionario_cargo.funcionario_cargo_nome
                    });

                }

                let adicionar = true;

                self.cargoItens.forEach(function (item) {
                    if (obj.funcionario_cargo_id === item.funcionario_cargo_id) {
                        adicionar = false;
                    }
                });

                if (adicionar) {
                    self.cargoItens.push({
                        funcionario_cargo_id: obj.funcionario_cargo_id,
                        funcionario_cargo_nome: obj.funcionario_cargo.funcionario_cargo_nome
                    });
                }

                let adicionarEmpresa = true;
                self.empresaItens.forEach(function (item) {
                    if (obj.empresa.empresa_id === item.empresa_id) {
                        adicionarEmpresa = false;
                    }
                });
                if (adicionarEmpresa) {
                    self.empresaItens.push({
                        empresa_id: obj.empresa.empresa_id,
                        empresa_nome_fantasia: obj.empresa.empresa_nome_fantasia
                    });
                }

                /// montando dados de filtro
                self.funcionarios[obj.funcionario_id] = {
                    pessoa_nome: obj.pessoa.pessoa_nome,
                    pessoa_profissao: obj.pessoa.pessoa_profissao || 'Não Informado',
                    id: obj.funcionario_id
                };
            });
            self.paginationConfig.qty = self.gridData.length;
            self.paginationConfig.itens = ListHelper.getInterval(self.gridData, self.paginationConfig.current, self.paginationConfig.perPage);

        });
    },
    watch: {
        'paginationConfig.current'() {
            this.paginationConfig.itens = ListHelper.getInterval(this.gridData, this.paginationConfig.current, this.paginationConfig.perPage);
        },
        'gridData'() {
            this.paginationConfig.qty = this.gridData.length;
            this.paginationConfig.current = 1;
            this.paginationConfig.itens = ListHelper.getInterval(this.gridData, 1, this.paginationConfig.perPage);
        },
        checkCargo() {
            this.filtrar();
        },
        checkEmpresa() {
            this.filtrar();
        },
        checkFuncionarios() {
            this.filtrar();
        },

        'filtro.funcionario'() {
            this.funcionariosFiltered = [];
            const func = this.filtro.funcionario;
            if (func) {
                this.funcionariosFiltered = this.funcionarios.filter(resp => {
                    return resp.pessoa_nome.toLowerCase().includes(func.toLowerCase())
                });
            }
        },
    },
    computed: {

        gridColumns() {

            if (this.statusSimulador === 2) {
                return ['id', 'Nome', 'Cargo'];
            }

            return ['id', 'Nome', this.lang.empresas, 'Cargo'];
        },


        getFuncionarioData() {
            if (!this.checkFuncionarios.length) {
                return [];
            }
            return this.funcionarios.filter(func =>
                this.checkFuncionarios.some(checkFunc => checkFunc == func.id))
        },
    },
    methods: {
        removeFilterFuncionario(id) {
            this.checkFuncionarios = this.checkFuncionarios.filter(check => check != id);
        },
        clearFieldFuncionario() {
            this.filtro.funcionario = '';
            this.funcionariosFiltered = [];
        },
        setCurrent(current) {
            this.paginationConfig.current = current;
        },
        clearFilter(e) {
            // debugger;
            // console.log(e);
            // alert(9);
            this.checkCargo = [];
            this.checkEmpresa = [];
            this.checkFuncionarios = [];
            this.funcionariosFiltered = [];
            this.filtro.funcionario = '';
        },
        filtrar() {
            // if (this.filtro.cargo.length === 0 &&
            //     this.filtro.empresa.length === 0
            // ) {
            //     Message.messageError('Selecione pelo menos um filtro.');
            //     return;
            // }

            this.gridData = [];
            this.itens.forEach((obj) => {
                let incluiCargo = true;
                if (this.checkCargo.length !== 0) {
                    if (!this.checkCargo.includes('all')) {
                        incluiCargo = this.checkCargo.includes(obj.funcionario_cargo_id);
                    }
                }

                let incluiEmpresa = true;
                if (this.checkEmpresa.length !== 0) {
                    if (!this.checkEmpresa.includes('all')) {
                        incluiEmpresa = this.checkEmpresa.includes(obj.empresa_id);
                    }
                }
                let incluiFuncionario = true;
                if (this.checkFuncionarios.length !== 0) {
                    incluiFuncionario = this.checkFuncionarios.includes(obj.funcionario_id);
                }
                if (incluiCargo && incluiEmpresa && incluiFuncionario) {
                    if (isMultiEmpresa) {
                        this.gridData.push({
                            id: obj.funcionario_id,
                            Nome: obj.pessoa.pessoa_nome,
                            Franquia: obj.empresa.empresa_nome_fantasia,
                            Cargo: obj.funcionario_cargo.funcionario_cargo_nome
                        });
                    } else {
                        this.gridData.push({
                            id: obj.funcionario_id,
                            Nome: obj.pessoa.pessoa_nome,
                            Empresa: obj.empresa.empresa_nome_fantasia,
                            Cargo: obj.funcionario_cargo.funcionario_cargo_nome
                        });
                    }
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/usuarios/Listagem.vue